/**
 * SubCategory entity class
 */

import { remove } from 'app/helpers/entity'

/**
 * SubCategoryFactory
 * returns SubCategory entity class
 *
 * @class SubCategoryFactory
 * @memberof mwApp
 * @see mwApp
 * @return {Function} {@link models.SubCategory} class
 *
 * @ngdoc factory
 * @name mwApp.factory:SubCategoryFactory
 */
/* @ngInject */
export default function SubCategoryFactory (Entity, Category) {
  /* === SubCategory class === */

  /**
   * SubCategory model
   *
   * @class SubCategory
   * @classdesc SubCategory model
   * @memberof models
   * @see models
   * @extends models.Category
   * @param {Object} [object] - initial object, containing SubCategory entity fields
   * @return {models.SubCategory} SubCategory entity
   */
  function SubCategory () {
    var obj = Category.apply(this, arguments)
    if (obj) {
      return obj
    }
  }
  SubCategory.prototype = Object.create(Category.prototype)
  SubCategory.prototype.constructor = SubCategory

  /* === SubCategory instance methods & fields === */

  Object.assign(SubCategory.prototype, {

    /**
     * url template
     *
     * @memberof models.SubCategory#
     * @type {String}
     */
    _urlTemplate: 'api/sets/{{::categorySet.id}}/categories/{{::parentCategory.id}}/subcategories/{{::id}}',

    /**
     * public url template
     *
     * @memberof models.SubCategory#
     * @type {String}
     */
    _publicUrlTemplate: 'sets/{{::categorySet.id}}/categories/{{::parentCategory.id}}/subcategories/{{::id}}',

    /**
     * Save/update subcategory, performing PUT/POST request to backend
     *
     * @memberof models.SubCategory#
     * @return {Promise} promise
     * @override
     */
    _save: function () {
      var isNew = this._isNew()
      return Entity.prototype._save.apply(this, arguments)
        .then(
          () => {
            if (isNew && this.parentCategory) {
              // add SubCategory to parent Category.subCategories array
              this.parentCategory.subCategories = this.parentCategory.subCategories || []
              this.sortOrder = this.__next_sort_order(this.parentCategory.subCategories)
              this.parentCategory.subCategories.push(this)
            }
          }
        )
    },

    /**
     * Delete subcategory, performing DELETE request to backend
     * and removing category from parent Category
     *
     * @memberof models.SubCategory#
     * @return {Promise} promise
     * @override
     */
    _delete: function () {
      return Entity.prototype._delete.apply(this, arguments)
        .then(
          () => {
            if (this.parentCategory && this.parentCategory.subCategories && this.parentCategory.subCategories.length > 0) {
              remove(this.parentCategory.subCategories)(this)()
            }
          }
        )
    }

  })

  /* === SubCategory static methods & fields === */

  // copy all static methods from Category class
  Object.assign(SubCategory, Category)
  SubCategory._name = 'SubCategory'
  SubCategory.init()

  // permissions
  SubCategory.access = {
    view: 'viewTvChannelCategory viewRadioChannelCategory viewVodCategory viewTvShowCategory | | |',
    create: 'createTvChannelCategory createRadioChannelCategory createVodCategory createTvShowCategory | | |',
    edit: 'editTvChannelCategory editRadioChannelCategory editVodCategory editTvShowCategory | | |',
    delete: 'deleteTvChannelCategory deleteTvChannelCategory deleteVodCategory deleteTvShowCategory | | |'
  }

  return SubCategory
}
